/*********************** Custom JS for Boost AI Search & Discovery  ************************/
/* 
  function onPageLoad() {
    if (window.location.href.includes("collections") && !window.location.href.includes("?pf_v_vendor=East")) {
      var newUrl = window.location.href + "?pf_v_vendor=East";
      history.replaceState(null, "", newUrl);
    }
  }

  // Use the DOMContentLoaded event instead of onload
  document.addEventListener("DOMContentLoaded", onPageLoad);

*/

//////////////////////
///////////////////////
/* Boost Recommended Method for Changes */



/* This is successfully modifying the object */
window.__BoostCustomization__ = (window.__BoostCustomization__ ?? []).concat([
  (componentRegistry) => {
    componentRegistry.useComponentPlugin('ProductLabel', {
      name: 'Modify Product Label',
      enabled: true,
      apply: () => ({
        afterRender(element) {
          // Get ProductItem element - the parent of ProductLabel element
          const parent = componentRegistry.getParentElmByPath(element, 'ProductItem.ProductLink.ProductImage');
          
          // Check if the parent object is present and is an object
          if (parent && typeof parent === 'object') {
            // Manipulate the object (for example, add a new property)
            parent.additionalText = 'Your additional text here';

            // Log the modified parent object to the console
            console.log(parent);
          } else {
            console.error('Parent is not a valid object:', parent);
          }
        },
      }),
    });
  }
]);